
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { FileText, Home } from "lucide-react";

interface ReportsHeaderProps {
  hasData: boolean;
}

export const ReportsHeader = ({ hasData }: ReportsHeaderProps) => {
  return (
    <div className="mb-8">
      <div className="bg-gradient-to-r from-primary-teal/15 via-primary-blue/10 to-primary-green/15 border border-primary-teal/20 rounded-lg p-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-primary-navy flex items-center gap-2">
            <FileText className="h-6 w-6" />
            التقارير والإحصائيات
          </h1>
        </div>
        <p className="text-primary-navy/70 mt-2 text-right">تحليل شامل لحضور الطلاب من البيانات المسجلة فعلياً</p>
      </div>
    </div>
  );
};
